/**
 * Custom hook to check if student has instant practice exams
 * Makes API call to /exam/has-instant-practice endpoint
 */

import { useState, useEffect } from 'react';
import { instance } from '../../../constants/constString';

/**
 * Custom hook to check if student has instant practice exams
 * @returns {Object} { hasInstantExam: boolean, isLoading: boolean, error: Error | null }
 */
export const useHasInstantExam = () => {
  const [hasInstantExam, setHasInstantExam] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const checkHasInstantExam = async () => {
      try {
        setIsLoading(true);
        setError(null);
        
        const response = await instance.get('/exam/has-instant-practice');
        
        if (isMounted) {
          const result = response?.data?.data?.hasInstantExam || false;
          setHasInstantExam(result);
        }
      } catch (err) {
        console.error('Error checking instant exam availability:', err);
        if (isMounted) {
          setError(err);
          setHasInstantExam(false); // Default to false on error
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    checkHasInstantExam();

    return () => {
      isMounted = false;
    };
  }, []);

  return { hasInstantExam, isLoading, error };
};

